import { DonationTabs, DonationTabsType } from "@/constants";
import { cn } from "@/libs/cn";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";

const Filters = [
    {
        title: "ဆွမ်း အလှူရှင်များစာရင်း",
        value: DonationTabs.alms_donors,
    },
    {
        title: "မတည်ငွေ အလှူရှင်များစာရင်း",
        value: DonationTabs.founding_donors,
    },
    {
        title: "ပဒေသာပင် အလှူရှင်များစာရင်း",
        value: DonationTabs.padetha_donors,
    }
]

export function DonationFilter() {

    const searchParams = useLocation().search;
    const nav = useNavigate();

    const currentTab = new URLSearchParams(searchParams).get("tab") as DonationTabsType;

    const activeTab = currentTab in DonationTabs
        ? currentTab
        : DonationTabs.alms_donors;

    const onTabChange = (value: string) => {
        const params = new URLSearchParams(searchParams);
        params.set("tab", value);
        nav({
            pathname: `/donations`,
            search: params.toString(),
        });
    }

    return (
        <div
            className="flex gap-2"
        >
            {
                Filters.map((item) => (
                    <Button
                        key={item.value}
                        onClick={() => onTabChange(item.value)}
                        type={activeTab === item.value ? "primary" : "default"}
                        className={cn(" active:!bg-transparent", {
                            "bg-primary-gradient": activeTab === item.value,
                            "hover:!text-f80 hover:!border-f80": activeTab !== item.value,
                        })}
                        shape="round"
                        size="large"
                    >
                        {item.title}
                    </Button>
                ))
            }
        </div>
    )
}
